import { render } from "./premium.vue?vue&type=template&id=89b20bfa&scoped=true"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"

import "./premium.vue?vue&type=style&index=0&id=89b20bfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b20bfa"]])

export default __exports__